import { useState } from "react";
import { Form, Button, Col, Container, Row } from "react-bootstrap";
import AdvancedAddressesFilters from "./AdvancedAddressesFilters";
import PostcodeInput from "../Common/PostcodeInput";

const AddressesFilters = ({
  onFilterChange,
  onSearch,
  onImmediateFilterChange,
  filters = {},
}) => {
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  return (
    <Container className="mt-4">
      <Form
        onKeyDown={(e) => {
          if (
            e.key === "Enter" &&
            !["TEXTAREA", "SELECT"].includes(e.target.tagName)
          ) {
            e.preventDefault();
            onSearch?.();
          }
        }}
      >
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="cityName">
              <Form.Label>Miejscowość</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.cityName || ""}
                onChange={(e) => onFilterChange("cityName", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="postcode">
              <Form.Label>Kod pocztowy</Form.Label>
              <PostcodeInput
                value={filters.postcode || ""}
                placeholder="__-___"
                onChange={(val) => onFilterChange("postcode", val)}
                inputMode="numeric"
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="streetName">
              <Form.Label>Ulica</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.Street ?? filters.streetName ?? ""}
                onChange={(e) => onFilterChange("Street", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="terminalDR">
              <Form.Label>Terminal DR</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.terminalDr ?? filters.terminalDR ?? ""}
                onChange={(e) => onFilterChange("terminalDr", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="terminalEX">
              <Form.Label>Terminal EX</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.terminalEx ?? filters.terminalEX ?? ""}
                onChange={(e) => onFilterChange("terminalEx", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2} className="d-flex align-items-end">
            <Button
              variant="primary"
              type="button"
              className="w-100"
              style={{ backgroundColor: "#D40511", borderColor: "#D40511" }}
              onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
            >
              {showAdvancedFilters ? "Podstawowy" : "Zaawansowany"}
            </Button>
          </Col>
        </Row>
        {showAdvancedFilters && (
          <AdvancedAddressesFilters
            onFilterChange={onFilterChange}
            onImmediateFilterChange={onImmediateFilterChange}
            filters={filters}
          />
        )}
      </Form>
    </Container>
  );
};

export default AddressesFilters;
